/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type DashboardViewDataModal_report = ReadonlyArray<{
    readonly entity: string;
    readonly categories: {
        readonly airtime: {
            readonly categories: ReadonlyArray<{
                readonly spoke: string;
                readonly spokeAcc: string;
                readonly email: string;
                readonly cellNumber: string;
                readonly isNull: boolean;
                readonly name: string;
                readonly key: string;
                readonly yesterdaysSalesToDate: number;
                readonly currentMonthToDate: number;
                readonly lastMonth: number;
                readonly lastMonthMonthToDate: number;
            }>;
            readonly totalRollup: {
                readonly spoke: string;
                readonly spokeAcc: string;
                readonly email: string;
                readonly cellNumber: string;
                readonly isNull: boolean;
                readonly name: string;
                readonly key: string;
                readonly yesterdaysSalesToDate: number;
                readonly currentMonthToDate: number;
                readonly lastMonth: number;
                readonly lastMonthMonthToDate: number;
            };
        } | null;
        readonly data: {
            readonly categories: ReadonlyArray<{
                readonly spoke: string;
                readonly spokeAcc: string;
                readonly email: string;
                readonly cellNumber: string;
                readonly isNull: boolean;
                readonly name: string;
                readonly key: string;
                readonly yesterdaysSalesToDate: number;
                readonly currentMonthToDate: number;
                readonly lastMonth: number;
                readonly lastMonthMonthToDate: number;
            }>;
            readonly totalRollup: {
                readonly spoke: string;
                readonly spokeAcc: string;
                readonly email: string;
                readonly cellNumber: string;
                readonly isNull: boolean;
                readonly name: string;
                readonly key: string;
                readonly yesterdaysSalesToDate: number;
                readonly currentMonthToDate: number;
                readonly lastMonth: number;
                readonly lastMonthMonthToDate: number;
            };
        } | null;
        readonly billPayments: {
            readonly categories: ReadonlyArray<{
                readonly spoke: string;
                readonly spokeAcc: string;
                readonly email: string;
                readonly cellNumber: string;
                readonly isNull: boolean;
                readonly name: string;
                readonly key: string;
                readonly yesterdaysSalesToDate: number;
                readonly currentMonthToDate: number;
                readonly lastMonth: number;
                readonly lastMonthMonthToDate: number;
            }>;
            readonly totalRollup: {
                readonly spoke: string;
                readonly spokeAcc: string;
                readonly email: string;
                readonly cellNumber: string;
                readonly isNull: boolean;
                readonly name: string;
                readonly key: string;
                readonly yesterdaysSalesToDate: number;
                readonly currentMonthToDate: number;
                readonly lastMonth: number;
                readonly lastMonthMonthToDate: number;
            };
        } | null;
        readonly entertainment: {
            readonly categories: ReadonlyArray<{
                readonly spoke: string;
                readonly spokeAcc: string;
                readonly email: string;
                readonly cellNumber: string;
                readonly isNull: boolean;
                readonly name: string;
                readonly key: string;
                readonly yesterdaysSalesToDate: number;
                readonly currentMonthToDate: number;
                readonly lastMonth: number;
                readonly lastMonthMonthToDate: number;
            }>;
            readonly totalRollup: {
                readonly spoke: string;
                readonly spokeAcc: string;
                readonly email: string;
                readonly cellNumber: string;
                readonly isNull: boolean;
                readonly name: string;
                readonly key: string;
                readonly yesterdaysSalesToDate: number;
                readonly currentMonthToDate: number;
                readonly lastMonth: number;
                readonly lastMonthMonthToDate: number;
            };
        } | null;
        readonly ticketing: {
            readonly categories: ReadonlyArray<{
                readonly spoke: string;
                readonly spokeAcc: string;
                readonly email: string;
                readonly cellNumber: string;
                readonly isNull: boolean;
                readonly name: string;
                readonly key: string;
                readonly yesterdaysSalesToDate: number;
                readonly currentMonthToDate: number;
                readonly lastMonth: number;
                readonly lastMonthMonthToDate: number;
            }>;
            readonly totalRollup: {
                readonly spoke: string;
                readonly spokeAcc: string;
                readonly email: string;
                readonly cellNumber: string;
                readonly isNull: boolean;
                readonly name: string;
                readonly key: string;
                readonly yesterdaysSalesToDate: number;
                readonly currentMonthToDate: number;
                readonly lastMonth: number;
                readonly lastMonthMonthToDate: number;
            };
        } | null;
        readonly electricity: {
            readonly categories: ReadonlyArray<{
                readonly spoke: string;
                readonly spokeAcc: string;
                readonly email: string;
                readonly cellNumber: string;
                readonly isNull: boolean;
                readonly name: string;
                readonly key: string;
                readonly yesterdaysSalesToDate: number;
                readonly currentMonthToDate: number;
                readonly lastMonth: number;
                readonly lastMonthMonthToDate: number;
            }>;
            readonly totalRollup: {
                readonly spoke: string;
                readonly spokeAcc: string;
                readonly email: string;
                readonly cellNumber: string;
                readonly isNull: boolean;
                readonly name: string;
                readonly key: string;
                readonly yesterdaysSalesToDate: number;
                readonly currentMonthToDate: number;
                readonly lastMonth: number;
                readonly lastMonthMonthToDate: number;
            };
        } | null;
        readonly other: {
            readonly categories: ReadonlyArray<{
                readonly spoke: string;
                readonly spokeAcc: string;
                readonly email: string;
                readonly cellNumber: string;
                readonly isNull: boolean;
                readonly name: string;
                readonly key: string;
                readonly yesterdaysSalesToDate: number;
                readonly currentMonthToDate: number;
                readonly lastMonth: number;
                readonly lastMonthMonthToDate: number;
            }>;
            readonly totalRollup: {
                readonly spoke: string;
                readonly spokeAcc: string;
                readonly email: string;
                readonly cellNumber: string;
                readonly isNull: boolean;
                readonly name: string;
                readonly key: string;
                readonly yesterdaysSalesToDate: number;
                readonly currentMonthToDate: number;
                readonly lastMonth: number;
                readonly lastMonthMonthToDate: number;
            };
        } | null;
    };
    readonly " $refType": "DashboardViewDataModal_report";
}>;
export type DashboardViewDataModal_report$data = DashboardViewDataModal_report;
export type DashboardViewDataModal_report$key = ReadonlyArray<{
    readonly " $data"?: DashboardViewDataModal_report$data;
    readonly " $fragmentRefs": FragmentRefs<"DashboardViewDataModal_report">;
}>;



const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "spoke",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "spokeAcc",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "cellNumber",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isNull",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "key",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "yesterdaysSalesToDate",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currentMonthToDate",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastMonth",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastMonthMonthToDate",
    "storageKey": null
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "DetailedSalesReportSales",
    "kind": "LinkedField",
    "name": "categories",
    "plural": true,
    "selections": (v0/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "DetailedSalesReportSales",
    "kind": "LinkedField",
    "name": "totalRollup",
    "plural": false,
    "selections": (v0/*: any*/),
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "DashboardViewDataModal_report",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entity",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DetailedSalesReportCategories",
      "kind": "LinkedField",
      "name": "categories",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DetailedSalesReportCategory",
          "kind": "LinkedField",
          "name": "airtime",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DetailedSalesReportCategory",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DetailedSalesReportCategory",
          "kind": "LinkedField",
          "name": "billPayments",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DetailedSalesReportCategory",
          "kind": "LinkedField",
          "name": "entertainment",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DetailedSalesReportCategory",
          "kind": "LinkedField",
          "name": "ticketing",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DetailedSalesReportCategory",
          "kind": "LinkedField",
          "name": "electricity",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DetailedSalesReportCategory",
          "kind": "LinkedField",
          "name": "other",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DetailedSalesReport",
  "abstractKey": null
};
})();
(node as any).hash = '8053d5095ee0f222b52d4ae0fc4374b6';
export default node;
